<template lang="pug">
b-modal#editProvider(
  ref="editProvider"
  :title="$t('ui.edit_provider')"
  centered
  no-fade
  no-close-on-backdrop
  ok-only
  ok-variant="secondary"
  size="md"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  template(v-for="group, key in providerGroup")
    .card.p-0.mx-0.mt-0.mb-3
      .card-header.bg-gradient-light.px-3.py-2.rounded-top
        .text-xxs.font-weight-bolder.text-secondary.text-uppercase {{ $t("ui." + key.toLowerCase()) }}
      .card-body.px-3.pt-2.pb-0.rounded-bottom
        form
          .d-flex.flex-wrap
            .w-50(v-for="item, key in group")
              .form-group.p-0.m-0.mb-2
                .form-check.form-switch.d-flex.align-items-center.justify-content-start
                  label.switch.switch-label.switch-info.mb-0
                    input(type="checkbox" class="switch-input" v-model="item.enable_provider" @change="change(item, $event)")
                    span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                  b.form-check-label.text-info.m-0.ml-2 {{ item.provider_code }}
  .row
    .col
      b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      parentId: null,
      isMember: false,
      item: {},
      accountId: "",
      providerList: [],
      providerGroup: {},
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {},
  methods: {
    change(e) {
      console.log(e);
      if (this.loading) return;
      this.loading = true;
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        target_account_id: e.account_id,
        enable: e.enable_provider,
        provider_code: e.provider_code,
        provider_type: e.provider_type,
        parent_id: this.parentId || null
      };
      var endpoint = xhr.ACCOUNT.updateProvider;
      if (this.isMember == true) {
        endpoint = xhr.ACCOUNT.updateMemberProvider;
      }
      xhr
        .doRequest(args, endpoint)
        .then(res => {
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;
          if (res.success == true) {
            this.$helpers.showDialog(this.$t("ui.edit_provider"), this.$t("message.success"), "success");
          } else {
            this.$helpers.handleFeedback(this.feedback.status);
          }
          this.populate();
          this.$emit("done");
        })
        .catch(res => {
          this.loading = false;
          if (res.status.toLowerCase() == "nochanges") {
          } else {
            this.feedback.success = false;
            this.feedback.status = res.status;
          }
          this.populate();
          this.$emit("done");
        });
    },
    populate() {
      this.loading = true;
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        target_account_id: this.accountId
      };
      var endpoint = xhr.ACCOUNT.providerList;
      if (this.isMember == true) {
        endpoint = xhr.ACCOUNT.memberProviderList;
      }
      xhr
        .doRequest(args, endpoint)
        .then(res => {
          this.loading = false;
          if (res.success == true) {
            this.providerList = res.data;
            this.providerGroup = {};
            for (var i in this.providerList) {
              var k = this.providerList[i].provider_type;
              if (this.providerGroup[k] == null) {
                this.providerGroup[k] = [];
              }
              this.providerGroup[k].push(this.providerList[i]);
            }
          } else {
            this.providerList = [];
            this.providerGroup = {};
          }
        })
        .catch(res => {
          this.loading = false;
          this.providerList = [];
          this.providerGroup = {};
        });
    },
    done(evt) {
      this.$refs.editProvider.hide();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.accountId = this.item.account_id;
      this.populate();
    }
  }
};
</script>
